<template>
  <div class="quote-tab">
    <!--    <h1>Referral Rewards</h1>-->
    <div class="card">
      <div class="info">
        <div class="left">
          <span class="money">{{ money }}</span> Hold Dollars
        </div>
        <div class="right">
          <span
            v-if="form.customer_profile.code"
            class="referralCode mg-r-15">Referral Code: {{form.customer_profile.code}}
          </span>
          <v-button
            gray
            icon="qrcode"
            @click="showQrcCode">QRCode</v-button>
        </div>
      </div>
      <div class="btn">
        <v-button
          gray
          @click="handleHolddollar">
          <font-awesome-icon
            icon="user-lock"
            class="icon"></font-awesome-icon>
          Add/Subtract
        </v-button>
        <v-button
          gray
          @click="handleRedeem">Redeem Binance</v-button>
        <v-button
          gray
          @click="openSupportTicketDialog('new-credit-ticket')">New HD Transfer</v-button>
        <!-- <v-button
            v-else
            type="primary"
            size="small"
            plain
            @click="addBankAccount">Add Bank Account</v-button> -->
      </div>
    </div>
    <div class="filter-card">
      <div class="filter-top">
        <span class="search-title">Search</span>
        <div
          class="mg-r-10">
          <v-button
            gray
            stop
            @click="handleSelect('is_search_type')">{{selectSearchTypeName}}
            <i
              class="el-icon-caret-bottom"></i>
          </v-button>
          <v-select-list
            v-model="is_search_type"
            :list="hdSearchTypeList"
            @select="handleSelectSearchType"
          ></v-select-list>
        </div>
        <v-input
          v-model="search"
          :placeholder="searchTypeName"
          @keyEnter="filterData" />
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Refer Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item " >
            <span>Amount</span>
            <div class="inline-input">
              <v-input
                v-model.number="amount_start"
                type="number"
                @keyEnter="filterData"></v-input>
              <span class="to-span">to</span>
              <v-input
                v-model.number="amount_end"
                type="number"
                @keyEnter="filterData"></v-input>
            </div>
          </div>

        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Action Type
              <span
                class="all"
                @click="handlerSelectAll(globalOptions.credit_action)">Select All</span>
            </span>
            <v-checkbox-group
              v-model="action_type"
              :list="globalOptions.credit_action"
              :block="true"
              @change="filterData"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="transparent-block">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
      >
        <el-table-column
          label="Date">
          <template #default="{ row }">
            <span class="action-title">{{ row.created_date }}</span><br>
            <span>{{ row.created_time }}</span><br>
          </template>
        </el-table-column>
        <el-table-column
          label="Customer">
          <template #default="{ row }">
            <span class="name-title">{{ row.isrd_nm }}</span><br>
            <span>#{{ row.customer_id }}</span><br>
          </template>
        </el-table-column>
        <el-table-column
          width="400"
          label="Action">
          <template #default="{ row }">
            <span class="action-title">{{ row.action_language }}</span><br>
            <span v-if="row.name">{{ row.name }}</span><br  v-if="row.name">
            <span v-if="row.describe">{{ row.describe }}</span><br  v-if="row.describe">
          </template>
        </el-table-column>
        <el-table-column
          label="Credit">
          <template #default="{ row }">
            <span :class="row.credits < 0?'red':'black'">{{row.credits > 0?'+':''}}{{ row.credits | formatMoney(0, false)  }}</span><br>
          </template>
        </el-table-column>
        <el-table-column width="50">
          <template #default="{ row }">
            <font-awesome-icon
              icon="info-circle"
              class="pointer icon-info"
              @click="showDetail(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
    <new-credit-ticket
      ref="new-credit-ticket"
      :is-fina-account="isFina"
      :is-create-ticket="false"
      :form="customerParams"
    />

    <redeem-dialog
      ref="redeem"
      :customerId="customerId"
      :binancePayId="binancePayId"
      :balance="money"
      @update="handleUpdate"></redeem-dialog>

    <holddollar-dialog
      ref="holddollar"
      :customer="form.customer_profile"
      @update="handleUpdate"></holddollar-dialog>

    <holddollar-detail
      ref="hd-detail"
      :detailData="detailData"></holddollar-detail>
    <qr-code
      v-model="showCode"
      :form="customerParams"></qr-code>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import NewCreditTicket from '../../tickets/dialogs/new-credit-ticket'

import {getAccountReferralList} from '@/api/account'
import MixinFormat from '@/mixins/format'
import RedeemDialog from './popup/redeem-dialog.vue'
import HolddollarDialog from './popup/holddollar-dialog.vue'
import HolddollarDetail from '@/views/components/dialogs/holddollar-detail'
import QrCode from './popup/referral-qr-code'
export default {
  name: 'ReferralTab',
  components:{
    NewCreditTicket,
    RedeemDialog,
    HolddollarDialog,
    HolddollarDetail,
    QrCode
  },
  mixins: [MixinOptions,MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    isFina: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      statusOptions: [
        {
          name: 'Selected Quick Quote',
          id: 'Selected Quick Quote'
        },
        {
          name: 'Final Quote',
          id: 'Final Quote'
        }
      ],
      date: '',
      product_id: [],
      company_id: [],
      search: '',
      tableData: [],
      amount_start:'',
      amount_end:'',
      action_type:[],
      detailData: {},
      showCode:false,
      is_search_type:false,
      search_type:'order_sn',
    }
  },
  computed: {
    money() {
      return this.form.customer_profile.money
    },
    customerId() {
      let {customer_id=''} = this.$route.query||{}
      return customer_id
    },
    hasBank(){
      return this.form.customer_profile.bank_number
    },
    customerParams() {
      const {customer_profile = {}} = this.form
      const {id, cs_id,cs_name} = customer_profile
      return {
        assignee_id: cs_id,
        customer_id: this.customerId,
        ...customer_profile
      }
    },
    binancePayId(){
      return this.form.customer_profile.binance_pay_id
    },
    selectSearchTypeName(){
      let name = this.getOptionName('hdSearchTypeList',this.search_type)
      return name
    },
    searchTypeName(){
      let arr = [...this.hdSearchTypeList]
      arr.splice(0, 1)
      if(!this.search_type)
        return arr.map(item => item.name).join(', ')
      return this.selectSearchTypeName
    },
  },
  created() {
    this.network().getAccountReferralList()
  },
  methods: {
    handleSelect(target){
      this[target] = !this[target]
    },
    handleSelectSearchType({id}){
      this.search_type = id
      this.is_search_type = false
      if(this.search)
      { this.pageConfig.currentPage =1
        this.network().getAccountReferralList()
      }
    },
    showQrcCode(){
      this.showCode = true
    },
    openSupportTicketDialog(type) {
      // this.newTicketDialog = false
      this.$refs[type].changeDialog()
    },
    // addBankAccount(){
    //   this.$emit('activeName','profileTab')
    // },
    handleRedeem(){
      this.$refs['redeem'].changeDialog()
    },
    handleHolddollar(){
      this.$refs['holddollar'].changeDialog()
    },
    handlerSelectAll(list) {
      // let origin = ''
      // switch (target) {
      //   case 'action_type':
      //     origin = 'insurerOptions'
      //     break
      // }
      const data = list.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this.action_type = data
      this.filterData()
    },
    // todo 篩選還沒做
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getAccountReferralList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAccountReferralList()
    },
    handleUpdate(){
      this.$emit('update')
      this.network().getAccountReferralList()
    },
    showDetail(row){
      event.stopPropagation()
      const {id, action} = row
      this.detailData = {
        id,
        action
      }
      this.$refs['hd-detail'].changeDialog()
    },
    network() {
      return {
        getAccountReferralList: async () => {
          const { data } = await getAccountReferralList({
            refer_dt_start: this.date[0],
            refer_dt_end: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            action_type: this.action_type,
            search: this.search,
            page: this.pageConfig.currentPage,
            customer_id: this.customerId,
            amount_start:this.amount_start,
            amount_end:this.amount_end,
            search_type:this.search_type
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-tab {
    position: relative;
    h1 {
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
    }
    .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 36px;
        .left {
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #6A737D;
          .money{
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            color: #24292E;
          }
        }
      .right{
        .referralCode{
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #586069;
        }
      }
    }
    .top-right {
        position: absolute;
        top: 0;
        right: 0;
    }
    .filter-container {
        .filter-box {
            margin-bottom: 10px;
            .label {
                display: block;
                padding-bottom: 5px;
                font-size: 14px;
                font-weight: bold;
                .all {
                    display: inline-block;
                    padding-left: 15px;
                    color: #409EFF;
                    font-weight: 400;
                    font-weight: 500;
                }
            }
            .search-box {
                width: 400px;
            }
            .quote-box {
                width: 300px;
            }
        }
    }
    .btn{
      margin-top: 20px;
      .icon{
        color: #586069;
      }
    }
  .filter-card {
    margin-bottom: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
        font-weight: 500;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;

      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 50%;
        //min-width: 290px;
      }
      .filter-middler {
        padding: 15px 10px;
        width: 50%;
        border-left: 1px solid #E1E4E8;
        //border-right: 1px solid #E1E4E8;
        //width: 300px;
      }
      .filter-right {
        padding-left: 10px;
      }
    }

  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.purple {
      background: #6F42C1;
    }
    &.red {
      background: #D73A49;
    }
  }
  .inline-input{
    display: flex;
    align-items: center;
    .to-span{
      margin: 0 10px;
    }
  }
  .transparent-block{
    border: 1px solid #E1E4E8;
    //border-bottom: 0;
    border-radius: 5px;
  }
  ::v-deep .tableHeader{
    background: #E1E4E8!important;

      th{
        background-color: #F6F8FA !important;
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: -0.15px;
        /* Text/text-gray-dark */
        color: #24292E!important;
      }

  }
  .name-title{
    color: #24292E;
    font-weight: bold;
  }
  .action-title{
    color: #24292E;
    font-weight: 500;
  }
  .red{
    color: #CB2431;

  }
  .black{
    color: #28A745;
  }
  .icon-info{
    color: #0366D6;
  }
}
::v-deep .el-input{
  input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{

    -webkit-appearance: none !important;

  }/* chrome */

  input[type="number"]{

    -moz-appearance:textfield;/* firefox */

  }
}
</style>
